import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
import highlight from 'flarum/common/helpers/highlight';
import tagIcon from '../../common/helpers/tagIcon';
import sortTags from '../../common/utils/sortTags';
/**
 * Tags for flarum/deck's picker, filtered from the ones already loaded rather
 * than searched for, as the forum payload has every tag the member can see.
 */
export default class DeckTagSearchSource {
  resource = 'tags';
  title() {
    return extractText(app.translator.trans('flarum-tags.forum.deck.tag_label'));
  }

  /** Nothing to fetch. */
  isCached() {
    return true;
  }
  async search() {}
  view(query) {
    const lower = query.toLowerCase();
    return sortTags(app.store.all('tags')).filter(tag => tag.name().toLowerCase().includes(lower)).map(tag => m("li", {
      className: "DeckTagSearchResult",
      "data-index": 'tags' + tag.id(),
      "data-id": tag.id()
    }, m("button", {
      type: "button"
    }, tagIcon(tag), m("span", {
      className: "DeckTagSearchResult-name"
    }, highlight(tag.name(), query)))));
  }
  customGrouping() {
    return false;
  }
  fullPage() {
    return null;
  }
  gotoItem() {
    return null;
  }
}
flarum.reg.add('flarum-tags', 'forum/components/DeckTagSearchSource', DeckTagSearchSource);